<template>
  <v-content>
    <div class="staticHero">
      <v-img src="../assets/images/dev.jpg">
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <v-container>
              <div class="headline">About Me</div>
            </v-container>
          </v-col>
        </v-row>
      </v-img>
    </div>
    <div class="block">
      <v-container>
        <h4 class="white--text">
          Hi, I’m Yared Weldegebrial. A Full stack web developer, i have been
          working at AllenaTech Electronic Technologies (<a
            href="https://www.allenatech.com/"
            target="_blank"
            >Allenatech</a
          >),Mekelle for 2 years. i am working at Adey-Meselesh GMBH Addis Ababa
          and Portugal (<a href="http://adey-meselesh.de/" target="_blank"
            >Adey-Meselesh</a
          >) until now. I have worked with Buffl GMBH, Germany,Munich (<a
            href="http://adey-meselesh.de/"
            target="_blank"
            >Buffl</a
          >) for 11 months as Remote Frontend developer using ReactJs developer
          and Mobile App developer using Flutter. I’ve worked on project for
          clients like: EMR(Electronic Medical Record), Covid19_tracker,Hospital
          Management System and many personal projects using
          Reactjs,Vuejs,Angular as front end technologies and Nodejs as backend
          technologies and Flutter and react native for moble apps. <br />
          E-learning System <br />
          Doctor-Appointment Application.<br />

          I’ve spent the past 4 years working across different areas of
          application development; front-end development, developing site pages,
          app UI/UX,developing mobile applications. <br />
          Download and check my CV for my detail background ! <br />
          Interested in working together? Feel free to contact me for any
          project or collaboration using my contact medias below..
        </h4>
      </v-container>
    </div>
    <!-- <div class="block">
      <v-container>
        <h2 class="text-center">Our Teams</h2>
        <v-row>
          <v-col v-for="item in items" :key="item.id" class="d-flex child-flex" cols="12" sm="4">
            <v-card flat tile class="mx-auto">
              <v-img :src="item.src" aspect-ratio="1" class="grey lighten-2"></v-img>
              <v-card-text class="text--primary text-center">
                <div class="title">{{ item.name }}</div>
                <p>{{ item.title }}</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>-->
  </v-content>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      // items: [
      //   {
      //     id: 1,
      //     // src: require("../assets/images/team1.jpg"),
      //     name: "Peter Smith",
      //     title: "Director"
      //   },
      //   {
      //     id: 2,
      //     // src: require("../assets/images/team2.jpg"),
      //     name: "Roy Perry",
      //     title: "Photographer"
      //   },
      //   {
      //     id: 3,
      //     // src: require("../assets/images/team3.jpg"),
      //     name: "Lisa White",
      //     title: "Freelancer"
      //   }
      // ]
    };
  },
};
</script>
